import { Injectable } from '@angular/core';
import * as fs from 'file-saver-es';
import { Workbook } from 'exceljs';
import { DatePipe } from '@angular/common';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class Excel {
    constructor(private datepipe: DatePipe) { }
    public exportAsExcelFile(excelData): void {
        //Title, Header & Data
        const title = excelData.title;
        const header = excelData.headers
        const data = excelData.data;

        //Create a workbook with a worksheet
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet('Report');

        //Adding Header Row
        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '4167B8' },
                bgColor: { argb: '' }
            }
            cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12
            }
        });

        // Adding Data with Conditional Formatting
        data.forEach(d => {
            let row = worksheet.addRow(d);
            let sales = row.getCell(2);
            sales.numFmt = 'm/d/yyyy'; 
        }
        );
        worksheet.getColumn(3).width = 20;

        //Generate & Save Excel File
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, title + '.xlsx');
        });
    }

}
